import ForwardAddressGrid from './forwarding-address-grid';

export default function ForwardAddressPage() {
  return <ForwardAddressGrid />;
}
